/*
    Created By: Sai Prasad
    Created Date: 26/08/2022
    Jira Ticket: JUN-3152
    Description: capturing suites imported response and showing to user in a popup.
  */

import React from 'react';
import Col from '../Col';
import Row from '../Row';
import '../../pages/ServiceRequest/Popup.scss';
import { variables } from '../../Tenants';

const ResponsePopup = ({
    data,
    onPress
}) => {
    return (
        <div className='suites_popup'>
            <div className='custom_inside_popup'>
                <div style={{ textAlign: 'right' }}>
                    <div style={{ textAlign: 'right' }}>
                        <div className="filters_modal_top_coner_box">
                            <div className="filters_modal_close_icon" onClick={onPress}>
                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.96 12.75L19.5 18.29V19.75H18.04L12.5 14.21L6.96 19.75H5.5V18.29L11.04 12.75L5.5 7.21V5.75H6.96L12.5 11.29L18.04 5.75H19.5V7.21L13.96 12.75Z" fill="black" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='suite_heading'>{variables.suiteName} Uploaded Information</div>
                    {data.map((item, i) => {
                        return (
                            <div style={{ flexDirection: 'row', borderBottom: '1px solid #ccc' }} key={i}>
                                <div className='suite_number'>{variables.Suite} : {item.number}</div>
                                {item.areas.map((area, j) => {
                                    return (
                                        <div style={{ marginTop: 10 }} key={j}>
                                            <Row>
                                                <Col
                                                    xs="12"
                                                    md="2">
                                                    <div className='area_name'>{area.name}:</div>
                                                </Col>
                                                <Col
                                                    xs="12"
                                                    md="10">
                                                    <Row>
                                                        {area.assets.map((asset, k) => {
                                                            return (
                                                                <Col
                                                                    key={k}
                                                                    xs="12"
                                                                    md="4"
                                                                >
                                                                    <div style={{ paddingBottom: 10 }}>
                                                                        <div className='asset_name_style'>{asset.name}</div> <div className={asset.status === "Success" ? 'success asset_name_style' : 'fail asset_name_style'}>{asset.status}</div>
                                                                        {asset.message && <div className='asset_name_style fail'>{asset.message}</div>}
                                                                    </div>
                                                                </Col>
                                                            )
                                                        })}
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </div>

                                    )
                                })}

                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default ResponsePopup;